import SiteInput from 'Site/component/SiteInput.vue';
import SiteTextArea from 'Site/component/SiteTextArea.vue';
import SiteSelect from 'Site/component/SiteSelect.vue';
import Form from 'Site/js/util/form';
import Loading from 'Site/component/Loading.vue';
import Location from 'Location/component/Location.vue';
import CheckBoxes from 'Site/component/CheckBoxes.vue';
import store from 'Site/js/store';
import { mapState } from 'vuex';
import Vue from 'vue';

export default function () {
    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        name: 'doggingForm',
        store,
        components: {
            CheckBoxes,
            Loading,
            Location,
            SiteInput,
            SiteSelect,
            SiteTextArea
        },
        computed: mapState(['t']),
        data() {
            const { data } = store.state.config;
            return {
                form: new Form({
                    name: data.name,
                    county: data.county,
                    location: data.location,
                    description: data.description,
                    anonymous: parseInt(data.anonymous, 10),
                    id: data.id,
                    geocompleteData: {
                        longitude: data.longitude,
                        latitude: data.latitude,
                    },
                }, {
                    name: [{ type: 'required' }, { type: 'max', value: 50 }],
                    county: ['required'],
                    description: ['required'],
                    location: ['required'],
                }),
                loading: false
            };
        },
        methods: {
            geocomplete(data) {
                this.form.geocompleteData = data;
                this.form.location = data.formatted;
            },
            validate(e) {
                let field = null;
                if (e) {
                    field = e.srcElement.name;
                }
                this.form.errors.clear(field);
                this.form.validate(field);
            },
            submit() {
                let form;
                if (this.form.id) {
                    form = this.form.update('dogging');
                } else {
                    form = this.form.create('dogging');
                }

                if (form) {
                    this.loading = true;
                    form.then(({ message, url }) => {
                        this.$store.dispatch('notify', { msg: message });
                        window.location = url;
                    }).catch(({ response }) => {
                        this.loading = false;
                        response.then((error) => {
                            this.$store.dispatch('notify', { type: 'error', msg: error.message });
                        });
                    });
                }
            },
        }
    });
}
